module.exports = __webpack_public_path__ + "static/img/search.51c5013.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/search.png
// module id = JdHl
// module chunks = 1